import React, { useState } from "react";
import EventCardShort from "../event-card/event-card-short";
import style from "./events.module.css";
import { TEvent } from "../../types";
import Heading from "../heading/heading";
import { getCookie } from "../../utils/cookie";
import { useGetMyEventsQuery } from "../../services/store/api/eventsApi";
import { useAppSelector } from "../../services/store/hooks";

type Tab = "all" | "mine";

interface Props {
    events: TEvent[];
}

const Events = ({ events }: Props) => {
    const [activeTab, setActiveTab] = useState<Tab>("all");
    const token = getCookie("token");
    const profile = useAppSelector((state) => state.user.profile);
    const hasProfile = Boolean(profile);
    
    const { data: myData, isFetching: myFetching } = useGetMyEventsQuery(undefined, {
        skip: !token || !hasProfile,
    });

    const myEvents = myData?.events ?? [];
    const isMyTab = hasProfile && activeTab === "mine";
    const displayEvents = isMyTab ? myEvents : events;

    const emptyMessage =
        isMyTab && !token
            ? "Войдите через Telegram, чтобы посмотреть свои записи."
            : isMyTab && !myFetching && myEvents.length === 0
                ? "У вас нет записей на мероприятия"
                : !isMyTab && events.length === 0
                    ? "Событий пока нет."
                    : "";

    return (
        <>
            <Heading tpl="new">События</Heading>
            <div className={style.container}>
                {hasProfile && (
                    <div className={style.tabs}>
                        <button
                            className={activeTab === "all" ? style.tabActive : ""}
                            onClick={() => setActiveTab("all")}
                        >
                            Все
                        </button>
                        <button
                            className={activeTab === "mine" ? style.tabActive : ""}
                            onClick={() => setActiveTab("mine")}
                        >
                            Мои
                        </button>
                    </div>
                )}
                <div className={style.events}>
                    {isMyTab && myFetching && (
                        <div className="text-center text-sm text-[#6b7280] mb-4">Загрузка...</div>
                    )}
                    {displayEvents.map((item) => (
                        <EventCardShort key={item.id} event={item} />
                    ))}
                    {!displayEvents.length && !myFetching && emptyMessage && (
                        <div className="p-5 text-center text-lg">{emptyMessage}</div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Events;
